import { IMAGES } from './site';

export interface Bonus {
  tag: string;
  title: string;
  subtitle: string;
  description: string;
  includes?: string[];
  value: string;
  image: string;
  alt: string;
}

export const bonuses: Bonus[] = [
  {
    tag: 'BONUS #1',
    title: 'DVO RED FLAG WORKFLOW™',
    subtitle: '50 Clinical Signals Worth a Closer Look',
    description:
      'A visual library of clinical signals organized into practical categories, designed to help you identify situations that may deserve additional assessment or review.',
    value: '$47',
    image: IMAGES.bonus1,
    alt: 'DVO Red Flag Workflow bonus materials',
  },
  {
    tag: 'BONUS #2',
    title: 'DVO MASTER FLOW MAP™',
    subtitle: 'The One-Page Visual DVO Workflow',
    description:
      'A condensed visual map connecting assessment, records, analysis, decision checkpoints, validation and reassessment. Designed to give you a fast overview of the complete workflow.',
    value: '$37',
    image: IMAGES.bonus2,
    alt: 'DVO Master Flow Map bonus materials',
  },
  {
    tag: 'BONUS #3',
    title: 'DVO WORKFLOW CASE LAB™',
    subtitle: '10 Cases to Practice Your Workflow',
    description:
      'Work through 10 educational complex-case scenarios and practice organizing the information using the DVO Clinical Workflow Builder™ framework.',
    includes: [
      'Case scenario',
      'Available information',
      'Workflow questions',
      'Information gaps',
      'Review checkpoints',
      'Planning considerations',
      'Self-review section',
    ],
    value: '$47',
    image: IMAGES.bonus3,
    alt: 'DVO Workflow Case Lab bonus materials',
  },
  {
    tag: 'BONUS #4',
    title: 'DVO WORKFLOW QUICK CARDS™',
    subtitle: '30 Rapid-Reference Workflow Cards',
    description:
      'Each card follows a simple structure: STAGE → QUESTION → INFORMATION → CHECKPOINT → REVIEW. Use the cards as a fast visual reference when organizing a complex case.',
    value: '$37',
    image: IMAGES.bonus4,
    alt: 'DVO Workflow Quick Cards bonus materials',
  },
  {
    tag: 'BONUS #5',
    title: 'DVO PRE-PLANNING WORKFLOW AUDIT™',
    subtitle: 'Your Final Workflow Review Before Moving Forward',
    description:
      'A structured audit designed to help you review the organization of your case before proceeding to the next stage according to your professional judgment.',
    includes: [
      'Information review',
      'Records review',
      'Assessment review',
      'Workflow completeness',
      'Attention points',
      'Final review checklist',
    ],
    value: '$29',
    image: IMAGES.bonus5,
    alt: 'DVO Pre-Planning Workflow Audit bonus materials',
  },
];
